import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { postInstoreCardLink } from 'core/actions/member';
import { useModal } from 'core/modules/Modal/ModalProvider';
import { selectUserIsIdentified } from 'core/selectors/user';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';

import config from 'core/modules/Instore2/components/InstoreOfferTile/configs';

function LinkButton({ offer, namespace }) {
  const dispatch = useDispatch();
  const { openModal } = useModal();
  const userIsIdentified = useSelector(selectUserIsIdentified);
  const { getButtonExpiringText } = config;
  const isMobileMQ = useSelector(selectIsMobileMQ);

  const {
    offerId, hasLinkedCards, cards, rclonMerchantName, expiringSoon,
  } = offer;

  const linkOffer = (event) => {
    event.stopPropagation();

    if (isEmpty(cards)) {
      openModal({
        name: 'mt_instoreAddNewCard2',
        params: {
          offerId,
          merchantName: rclonMerchantName,
        },
      });
      return true;
    }

    dispatch(postInstoreCardLink(offerId, {}, {}, { namespace, linkedFromTile: true, offer }));

    return true;
  };

  const buttonExpiringText = getButtonExpiringText(isMobileMQ);

  if (!userIsIdentified) {
    return <span className="mn_button mn_getOffer">Get offer</span>;
  }

  if (hasLinkedCards && expiringSoon) {
    return <span className="mn_button mn_expiringOffer">{buttonExpiringText}</span>;
  }

  if (hasLinkedCards) {
    return <span className="mn_button mn_linkedOffer">Offer linked</span>;
  }

  return <button className="mn_button mn_linkOffer" onClick={linkOffer}>Link offer</button>;
}

export default LinkButton;
